import TableHeader from "./TableHeader";
import UI from "@mile-meeting/mile-ui";
import TableRow from "./TableRow";
import { TRestrictRequest } from "apis/meetings/block-request";

type Props = {
  data: TRestrictRequest[];
  onClickItem: (item: TRestrictRequest) => void;
};
const ProcessedRequestTable = ({ data, onClickItem }: Props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }} className="tableContainer">
      <TableHeader />
      {data.length === 0 && <EmptyRow />}
      {data.length > 0 &&
        data
          .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
          .map((item) => <TableRow data={item} onClick={() => onClickItem(item)} />)}
    </div>
  );
};

export default ProcessedRequestTable;

const EmptyRow = () => {
  return (
    <div
      className="empty-row"
      style={{
        display: "flex",
        padding: "12px 24px",
        borderBottom: "1px solid var(--alias-color-line-normal)",
        alignItems: "center",
        gap: 8,
      }}
    >
      <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative)" />
      <UI.Typography type="body01 normal" fontStyle="regular">
        처리 완료된 요청이 없습니다.
      </UI.Typography>
    </div>
  );
};
